import React from "react";
import { FaSave, FaEdit } from "react-icons/fa";
import InlineAlert from "../../../UI/DesignStandards/Notifications/InlineAlert";
import {
  PrimaryButton,
  SecondaryButton,
} from "../../../UI/DesignStandards/Buttons";

const OrganizationDetailsSection = ({
  editingOrg,
  organizationData,
  saving,
  onEdit,
  onCancel,
  onChange,
  onSave,
  formError,
}) => {
  return (
    <div className="card-board p-4 sm:p-6 mb-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 space-y-3 sm:space-y-0">
        <h2 className="heading-display text-xl">Organization Details</h2>
        {!editingOrg && (
          <SecondaryButton onClick={onEdit} className="!px-3 !py-2 text-sm">
            <FaEdit className="w-4 h-4" />
            <span>Edit Details</span>
          </SecondaryButton>
        )}
      </div>

      {editingOrg ? (
        <div className="mb-6 p-4 card-inset">
          <h3 className="text-lg font-medium text-brand-charcoal mb-4">
            Edit Organization Details
          </h3>
          {formError ? (
            <div className="mb-3">
              <InlineAlert
                type="error"
                title="Please fix the following"
                message={formError}
              />
            </div>
          ) : null}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Organization Name *
              </label>
              <input
                type="text"
                value={organizationData.name}
                onChange={(e) => onChange("name", e.target.value)}
                className="w-full px-3 py-2 border border-brand-charcoal/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
                placeholder="Enter organization name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-brand-charcoal mb-2">
                Description
              </label>
              <textarea
                value={organizationData.description}
                onChange={(e) => onChange("description", e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border border-brand-charcoal/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
                placeholder="Describe your organization"
              />
            </div>
            <div className="flex items-center space-x-4">
              <PrimaryButton type="button" onClick={onSave} disabled={saving}>
                <FaSave className="w-4 h-4" />
                <span>{saving ? "Saving..." : "Save Changes"}</span>
              </PrimaryButton>
              <SecondaryButton type="button" onClick={onCancel} className="!px-3 !py-2 text-sm">
                Cancel
              </SecondaryButton>
            </div>
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-medium text-brand-charcoal">
              {organizationData.name}
            </h3>
            {organizationData.description && (
              <p className="text-brand-muted mt-2">
                {organizationData.description}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganizationDetailsSection;
